export enum Behaviours {
	SnapToWallBehaviour = "snap-to-wall",
	Spinning = "spinning",
}
